module.exports = __webpack_public_path__ + "img/building.e0f39dbf.png";